import { TpDataObject } from './interfaces';

/**
 * Check if an output data object is compatible with an input data object.
 */
export function getOutputInputCompatibility(
  output: TpDataObject,
  input: TpDataObject,
): {
  isCompatible: boolean;
  rejectionReason: string;
} {
  // At the moment, we only check if the types match.
  if (input.type != output.type)
    return {
      isCompatible: false,
      rejectionReason: `Expected output of type ${input.type} (found ${output.type})`,
    };
  return {
    isCompatible: true,
    rejectionReason: ',',
  };
}
